import React, { useEffect, useState } from "react";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { Button, FloatingLabel, Form } from "react-bootstrap";
import { useAuth } from "../../Context/AuthContext";
import { httpClient } from "../../utils/HttpClient";
import PropTypes from "prop-types";

const EditSmsPackage = ({ idSmsPackage, handleClose }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [validated, setValidated] = useState(false);
  const [values, setValues] = useState({
    packagename: "",
    totalsms: "",
    price: "",
    unitprice: "",
    isactive: true,
  });

  const getSmsPackage = () => {
    const URICustomer = ApiEndpoint + "smsPackage/" + idSmsPackage;

    httpClient("GET", URICustomer, {}, userData.token).then((response) => {
      setValues(response.data);
    });
  };

  useEffect(() => {
    getSmsPackage();
  }, []);

  const handleSubmit1 = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      return;
    }

    setValidated(true);
    const URICustomer = ApiEndpoint + "customer/";
    if (idSmsPackage > 0) {
      httpClient(
        "PUT",
        URICustomer + idSmsPackage,
        {
          name: values.name,
          comercialname: values.comercialname,
          rfc: values.rfc,
          address: values.address,
        },
        userData.token
      )
        .then(function () {
          handleClose();
          return;
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      httpClient(
        "POST",
        URICustomer,
        {
          name: values.name,
          comercialname: values.comercialname,
          rfc: values.rfc,
          address: values.address,
        },
        userData.token
      )
        .then(function (response) {
          console.log(response);
          handleClose();
          return;
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  const onChange = (event) => {
    const { name, value } = event.target;
    setValues({ ...values, [name]: value });
  };
  return (
    <>
      <Form noValidate validated={validated} onSubmit={handleSubmit1}>
        <FloatingLabel label="Nombre" className="mb-3">
          <Form.Control
            type="text"
            name="packagename"
            id="packagename"
            value={values.packagename}
            required
            onChange={(event) => {
              onChange(event);
            }}
            placeholder="Ingrese el identificador del paquete"
          />
        </FloatingLabel>

        <FloatingLabel label="Total de Eventos" className="mb-3">
          <Form.Control
            type="text"
            name="totalsms"
            id="totalsms"
            required
            value={values.totalsms}
            onChange={(event) => onChange(event)}
            placeholder="Ingrese el total de SMS"
          />
        </FloatingLabel>

        <FloatingLabel label="Precio" className="mb-3">
          <Form.Control
            type="text"
            name="price"
            id="price"
            value={values.price}
            onChange={(event) => onChange(event)}
            required
            placeholder="Ingrese el Precio total"
          />
        </FloatingLabel>

        <FloatingLabel label="Precio Unitario" className="mb-3">
          <Form.Control
            type="text"
            name="unitprice"
            id="unitprice"
            value={values.unitprice}
            onChange={(event) => onChange(event)}
            required
            placeholder="Ingrese el Precio por Evento"
          />
        </FloatingLabel>
        <FloatingLabel label="" className="mb-3">
          <Form.Check
            type="switch"
            id="isactive"
            value={values.isactive}
            label="Activo?"
            onChange={(event) => onChange(event)}
          />
        </FloatingLabel>
        <div className="text-right">
          <Button variant="primary" type="submit" className="align-self-end">
            {idSmsPackage > 0 ? "Actualizar" : "Guardar"}
          </Button>
        </div>
      </Form>
    </>
  );
};
EditSmsPackage.propTypes = {
  idSmsPackage: PropTypes.number.isRequired,
  handleClose: PropTypes.func.isRequired,
};
export default EditSmsPackage;
